import { useMemo } from 'react';

import formats from '@/shared/lib/constants/formats';
import Tag from '@/shared/ui/Tag';

type Props = {
  formatId: number;
};

export default function Format({ formatId }: Props) {
  const format = useMemo(() => {
    const current = formats.find((f) => f.value === formatId);

    return current || formats[0];
  }, [formatId]);

  return <Tag title={format.label} color={format.color} />;
}
